<div class="content-wrapper">
  <mat-card class="content">
    <div class="content-header">
      <h2>
        Alle audits
        <span>({{ allAudits() }})</span>
      </h2>
      <mat-form-field class="mat-form-field-no-subscript">
        <mat-label>Zoeken</mat-label>
        <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
        <button
          mat-icon-button
          matSuffix
          aria-label="Zoekopdracht wissen"
          (click)="clearSearch(); $event.stopPropagation()"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <form class="filters" [formGroup]="dateForm">
      <mat-form-field class="mat-form-field-no-subscript">
        <mat-label>Selecteer filter</mat-label>
        <mat-select (selectionChange)="periodFilter()" formControlName="selectedDateFilter">
          @for (filter of dateFilter(); track filter) {
            <mat-option [value]="filter.value">
              {{ filter.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (dateForm.value.selectedDateFilter == 'month') {
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Maand</mat-label>
          <mat-select (selectionChange)="periodFilter()" formControlName="selectedMonth">
            @for (month of months(); track month) {
              <mat-option [value]="month.value">{{ month.viewValue }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (dateForm.value.selectedDateFilter == 'week') {
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Week</mat-label>
          <mat-select (selectionChange)="periodFilter()" formControlName="selectedWeek">
            @for (week of weeks(); track week) {
              <mat-option [value]="week">{{ week }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field class="mat-form-field-no-subscript">
        <mat-label>Jaar</mat-label>
        <mat-select (selectionChange)="periodFilter()" formControlName="selectedYear">
          @for (year of years(); track year) {
            <mat-option [value]="year.value">{{ year.viewValue }} </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    @if (!loadingAudits()) {
      <div class="list-items">
        <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper" role="table" aria-label="Audit overzicht">
          <div class="list-item-wrapper headers" role="presentation">
            <div class="list-item-col-wrapper" role="row">
              <div class="list-item-col" role="columnheader">
                <div class="text-truncate">Naam</div>
              </div>
              <div class="list-item-col credits-col" role="columnheader">
                <div class="text-truncate">Credits</div>
              </div>
              <div class="list-item-col date-col hide-column-5" role="columnheader">
                <div class="text-truncate">Datum</div>
              </div>
              <div class="list-item-col hide-column-4" role="columnheader">
                <div class="text-truncate">Beschrijving</div>
              </div>
              <div class="list-item-col hide-column-2" role="columnheader">
                <div class="text-truncate">Voertuig</div>
              </div>
              @if (showCharacteristics()) {
                <div class="list-item-col hide-column-3" role="columnheader">
                  <div class="text-truncate">Kenmerken</div>
                </div>
              }
              <div class="list-item-col hide-column-3" role="columnheader">
                <div class="text-truncate">Opmerkingen</div>
              </div>
              <div class="list-item-col hide-column-1" role="columnheader">
                <div class="text-truncate">Behandelaar</div>
              </div>
            </div>
          </div>
          @for (audit of filteredAudits(); track audit.id) {
            <div class="list-item-wrapper" role="presentation">
              <div class="list-item-col-wrapper" role="row">
                <div class="list-item-col" role="cell">
                  @if (audit.userData.name) {
                    <div class="text-truncate">
                      {{ audit.userData.name }}
                    </div>
                  }
                </div>
                <div class="list-item-col credits-col" role="cell">
                  @if (audit.creditsAdded) {
                    <div class="text-truncate">
                      <span class="credits-added">+{{ audit.creditsAdded }}</span>
                    </div>
                  } @else if (audit.creditsSpent) {
                    <div class="text-truncate">
                      <span class="credits-spent">-{{ audit.creditsSpent }}</span>
                    </div>
                  }
                </div>
                <div class="list-item-col date-col hide-column-5" role="cell">
                  <div class="text-truncate">
                    {{ audit.date.toDate() | date: 'dd-MM-yyyy HH:mm' }}
                  </div>
                </div>
                <div class="list-item-col hide-column-4" role="cell">
                  <div class="text-truncate">
                    {{ audit.description }}
                  </div>
                </div>
                <div class="list-item-col hide-column-2" role="cell">
                  <div class="text-truncate">
                    {{ getVehicleName(audit.vehicleId) }}
                  </div>
                </div>
                @if (showCharacteristics()) {
                  <div class="list-item-col hide-column-3" role="cell">
                    <div class="text-truncate">
                      {{
                        audit.characteristics?.length > 0 ? audit.characteristics.toString().replaceAll(',', ', ') : '-'
                      }}
                    </div>
                  </div>
                }
                <div class="list-item-col hide-column-3" role="cell">
                  <div class="text-truncate">
                    {{ audit.remarks }}
                  </div>
                </div>
                <div class="list-item-col hide-column-1" role="cell">
                  <div class="text-truncate email">
                    {{ audit.actionBy }}
                  </div>
                </div>
              </div>
            </div>
          }
        </cdk-virtual-scroll-viewport>
      </div>
    } @else {
      <div class="loading-wrapper" role="status" aria-live="polite" aria-atomic="true">
        <div class="loading">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
  </mat-card>
</div>
